export default "__VITE_ASSET__8787eda8__"